import { render, staticRenderFns } from "./storeTransfer.vue?vue&type=template&id=4b7118a8&"
import script from "./storeTransfer.vue?vue&type=script&lang=js&"
export * from "./storeTransfer.vue?vue&type=script&lang=js&"
import style0 from "./storeTransfer.vue?vue&type=style&index=0&id=4b7118a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports